import React from 'react';
import {array, arrayOf, bool, number, shape} from 'prop-types';
import distanceCalculator from 'utils/distanceCalculator';
import startPin from 'assets/images/icon_start.svg';
import connectIDGen from 'utils/connectIDGen';
import DynamicIcon from 'components/DynamicIcon';
import iconPinEnd from 'assets/images/icon_pin.svg';
import { mainPurple } from 'config/colors';
import styles from './styles.module.css';
import { pinSize } from 'config/sizes';

PathGuide.propTypes = {
  rotate: number,
  path: arrayOf(
    shape({
      id: number,
      cx: number,
      cy: number
    })
  ),
  notDestinationButElevator: bool,
};

function PathGuide(props) {
  const {
    path,
    rotate,
    notDestinationButElevator
  } = props;

  const startItem = path[0];
  const destItem = path[path.length - 1];
  
  return (
    <>
      {path.map((item, index, arr) => {
        if (path[index + 1]) {
          // current item
          const x1 = item.cx;
          const y1 = item.cy;
          // next item in the path array
          const x2 = path[index + 1]?.cx;
          const y2 = path[index + 1]?.cy;
          const connectionLength = distanceCalculator(item, arr[index + 1] ? arr[index + 1] : 0);
          const lineId = connectIDGen(x1, y1, x2, y2, connectionLength);

          const lineProps = {
            x1,
            y1,
            x2,
            y2,
            key: lineId,
            strokeWidth: '2',
            className: styles.path,
            stroke: mainPurple,
            strokeDasharray: '8',
            strokeLinecap: 'round',
          };
          if(index == path.length -2){
            return (
            <>
              <defs>
                <marker id="arrow" viewBox="0 -5 10 10" refX="5" refY="0" markerWidth="5" markerHeight="5" orient="auto" markerUnits="strokeWidth">
                  <path className="cool" d="M0,-5L10,0L0,5" fill="#D13D9E"></path>
                  {/* <polyline points="0,0 0,50 20,70 40,10 42,8 44,10, 46,14 50,50" stroke="none" fill="none" stroke-width="1"/> */}
                </marker>
              </defs>
              <line {...lineProps} markerEnd='url(#arrow)' />
            </>
            
            )
          }
          return (
            <line {...lineProps}/>
          )
        }
        return null;
      })}
      {
        <>
          {/* Destination point. Only show if it's not elevator or escalator */}
          {!notDestinationButElevator && (
            <DynamicIcon
              key={destItem.id + '_pinEnd'}
              logoRectSize={pinSize}
              rotate={rotate}
              x={destItem.cx}
              y={destItem.cy}
              href={iconPinEnd}
              animation
            />
          )}
        </>
      }
    </>
  );
}

export default PathGuide;